export default __webpack_public_path__ + "static/media/mockuper-2-768x531.ac4f899f.e3bda574.png";